import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" data-id="element-82">
      <div className="absolute inset-0 z-0" data-id="element-83">
        <img src="https://cdn.magicpatterns.com/uploads/rMP1HzxZ7VN1vFmy6GXjDj/arestaurante_cabrera.jpg" alt="Brindis con sangría en Cabrera" className="w-full h-full object-cover" data-id="element-84" />
        <div className="absolute inset-0 bg-[#0D0600]/80" data-id="element-85"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-87">
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-6" data-id="element-88">
            ¿Tienes planes para hoy?
          </h2>
          <p className="text-xl text-brand-cream/90 mb-10 font-light leading-relaxed" data-id="element-89">
            Reserva tu mesa ahora y vive la experiencia Cabrera. Una noche que
            no vas a olvidar.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-90">
            <a href="https://wa.me/573508108717" target="_blank" rel="noreferrer" className="w-full sm:w-auto px-8 py-4 rounded-full bg-[#25D366] text-white font-bold hover:bg-[#20b958] transition-all duration-300 flex items-center justify-center shadow-lg shadow-[#25D366]/20" data-id="element-91">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-92">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" data-id="element-93" />
              </svg>
              RESERVAR POR WHATSAPP
            </a>
            <a href="#menu" className="w-full sm:w-auto px-8 py-4 rounded-full border-2 border-brand-gold text-brand-gold font-semibold hover:bg-brand-gold hover:text-brand-primary transition-all duration-300" data-id="element-94">
              VER EL MENÚ COMPLETO
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}